import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-select-practice-modal',
  templateUrl: './select-practice-modal.component.html',
  styleUrls: ['./select-practice-modal.component.scss'],
})
export class SelectPracticeModalComponent implements OnInit {
  practices: any[] = [];
  selectedId: string | null = null;
  private allPractices: any[] = [];

  constructor(public activeModal: NgbActiveModal, private toastr: ToastrService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.allPractices = Array.isArray(this.practices) ? [...this.practices] : [];
    this.practices = [...this.allPractices];
  }

  select(selectedRecord: any): void {
    this.activeModal.close({patient : selectedRecord.uniq_id,practice_id : selectedRecord.practice_map.practice.practice_id});
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
